module.exports = __webpack_public_path__ + "static/media/reset_password.ad60dd4a.svg";